import { getLocalData, setLocalData } from 'utils/localDataStore';
import qs from 'qs';
import _isEmpty from 'lodash/isEmpty';

const LOCAL_STORAGE_KEY = 'lastLoginSourceData';

export const parseUtmParameters = () => {
  const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });

  let utmSource = params.utm_source || null;
  let utmCampaign = params.utm_campaign || null;

  // Handle redirect parameter (?redirect=%2F%3Futm_source%3D...)
  if ((!utmSource || !utmCampaign) && params.redirect) {
    try {
      const decoded = decodeURIComponent(params.redirect);
      const redirectParams = qs.parse(decoded.split('?')[1], {
        ignoreQueryPrefix: true,
      });
      utmSource = utmSource || redirectParams.utm_source || null;
      utmCampaign = utmCampaign || redirectParams.utm_campaign || null;
    } catch (error) {
      // ignore malformed redirect
    }
  }

  return {
    utm_source: utmSource,
    utm_campaign: utmCampaign,
  };
};

export const hasUtmParameters = () => {
  const { utm_source, utm_campaign } = parseUtmParameters();
  return !_isEmpty(utm_source) || !_isEmpty(utm_campaign);
};

export const saveLoginSource = (
  userId,
  sourceData = {},
  isAuthenticated = false,
) => {
  try {
    const utmParams = hasUtmParameters() ? parseUtmParameters() : sourceData;

    if (!utmParams.utm_source) {
      return;
    }

    const trackingData = {
      lastLoginSource: utmParams.utm_source,
      lastLoginCampaign: utmParams.utm_campaign || null,
      lastLoginTimestamp: Date.now(),
      userIdTemp: getLocalData('userIdTemp'),
      isAuthenticated,
      updatedAt: new Date().toISOString(),
    };

    if (isAuthenticated && userId) {
      trackingData.firebaseUid = userId;
    }

    setLocalData(LOCAL_STORAGE_KEY, JSON.stringify(trackingData));
  } catch (error) {
    console.error('[Source Tracking] Failed to save:', error);
  }
};

export const getLoginSource = () => {
  try {
    const cachedData = getLocalData(LOCAL_STORAGE_KEY);
    if (!cachedData) {
      return null;
    }

    const parsed = JSON.parse(cachedData);
    return parsed;
  } catch (error) {
    console.error('[Source Tracking] Failed to get login source:', error);
    return null;
  }
};

export const shouldUseHistoricalAttribution = () => !hasUtmParameters();

export const getHistoricalSourceData = () => {
  if (hasUtmParameters()) {
    return null;
  }

  const historicalData = getLoginSource();

  if (historicalData) {
    return {
      utm_source: historicalData.lastLoginSource,
      utm_campaign: historicalData.lastLoginCampaign,
      lastLoginTimestamp: historicalData.lastLoginTimestamp,
    };
  }

  return null;
};

export const clearLoginSourceCache = () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error('[Source Tracking] Failed to clear cache:', error);
  }
};

export default {
  parseUtmParameters,
  hasUtmParameters,
  saveLoginSource,
  getLoginSource,
  shouldUseHistoricalAttribution,
  getHistoricalSourceData,
  clearLoginSourceCache,
};
